import React from 'react';
/**
 * `SummaryPlan` renders a list of selected products as part of a customer's
 * plan summary.
 *
 * It filters the provided `products` to selected/purchased items and renders a
 * `SummaryProduct` for each, optionally showing a section title and edit/remove
 * actions.
 */
import { ProductType } from '../CommonTypes';
import { getSelectedProducts } from '../ProductMethods';
import SummaryProduct from './SummaryProduct';
import { useTranslation } from 'react-i18next';

export type SummaryPlanProps = {
  products: ProductType[];
  removeProduct?: (productTypeId: number) => void;
  showRemove: boolean;
  editProduct?: () => void;
  showEdit: boolean;
  showTitle: boolean;
  culture: string;
};

const SummaryPlan = ({
  products,
  removeProduct,
  showRemove,
  editProduct,
  showEdit,
  showTitle,
  culture
}: SummaryPlanProps): JSX.Element => {
  let selectedProducts: ProductType[] = [];

  const { t } = useTranslation();

  if (products && products !== undefined)
    selectedProducts = getSelectedProducts(products);
  return (
    <div>
      <div className='flex-row'>
        <div className='flex-column'>
          {showTitle && (
            <p className='p3 m1-bottom'>
              {t('summary.dealer-products-selected-title')}
            </p>
          )}

          {selectedProducts.map((product: ProductType) => (
            <SummaryProduct
              key={`summaryProduct-${product.productTypeId}`}
              product={product}
              removeProduct={removeProduct}
              showRemove={products.length === 1 ? false : showRemove}
              editProduct={editProduct}
              showEdit={showEdit}
              culture={culture}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SummaryPlan;
